// @ts-nocheck
(function() {'use strict';

angular.module('BCP')
  .constant('host', window._ENV.baseURL);

})();
